import { useState } from "react";

import { FileText, Video, ImageIcon } from "lucide-react";
import Logo from "../../assets/Logo.png";
import Demo from "../../Demo";
import VideoDemo from "../VideoDemo";
import ImageDemo from "../ImageDemo";

const Tab = () => {
  const [activeTab, setActiveTab] = useState("text");

  return (
    <div className="min-h-screen bg-white p-6 ">
      <div className="max-w-4xl mx-auto">
        <img src={Logo} alt="logo" className="h-14 w-14 mb-8" />

        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Analyze Any Type Of Content
          </h2>
          <p className="text-lg text-slate-600 max-w-xl mx-auto">
            Paste text, connect a link, or upload your Contents.
          </p>
        </div>

        <div className="flex gap-4 border-b border-slate-200 mb-8">
          <button
            onClick={() => setActiveTab("text")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors rounded-md ${
              activeTab === "text"
                ? "text-white bg-indigo-700 border-b-2 border-indigo-700 -mb-[2px]"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <FileText size={20} />
            Text
          </button>
          <button
            onClick={() => setActiveTab("video")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors rounded-md ${
              activeTab === "video"
                ? "text-white bg-indigo-700 border-b-2 border-indigo-700 -mb-[2px]"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <Video size={20} />
            Video
          </button>
          <button
            onClick={() => setActiveTab("image")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors rounded-md ${
              activeTab === "image"
                ? "text-white bg-indigo-700 border-b-2 border-indigo-700 -mb-[2px]"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <ImageIcon size={20} />
            Image
          </button>
        </div>

        <div className="bg-white border border-slate-200 rounded-lg p-8">
          {activeTab === "text" && <Demo />}
          {activeTab === "video" && <VideoDemo />}
          {activeTab === "image" && <ImageDemo />}
        </div>
      </div>
    </div>
  );
};

export default Tab;
